/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiAccountsCustomTranslationsRetrieveParams = zod.strictObject({
    format: zod.enum(['csv', 'json']).optional(),
});

export type ApiAccountsCustomTranslationsRetrieveParams = zod.input<
    typeof ApiAccountsCustomTranslationsRetrieveParams
>;
export type ApiAccountsCustomTranslationsRetrieveParamsOutput = zod.output<
    typeof ApiAccountsCustomTranslationsRetrieveParams
>;
